import { useMemo, useCallback } from 'react';
import Joyride, { STATUS, type CallBackProps } from 'react-joyride';
import { useTheme } from '@mui/material/styles';
import { buildAppTourSteps } from '../config/appTourSteps';

type Props = {
  run: boolean;
  onClose: () => void;
  isLgUp: boolean;
  showBottomBar: boolean;
  pathname: string;
  payOnlyMode: boolean;
  showBottomBarMore: boolean;
};

export default function AppTourJoyride({
  run,
  onClose,
  isLgUp,
  showBottomBar,
  pathname,
  payOnlyMode,
  showBottomBarMore,
}: Props) {
  const theme = useTheme();
  const isHome = pathname === '/home' || pathname === '/';

  const steps = useMemo(
    () => buildAppTourSteps({ isLgUp, showBottomBar, isHome, payOnlyMode, showBottomBarMore }),
    [isLgUp, showBottomBar, isHome, payOnlyMode, showBottomBarMore],
  );

  const handleCallback = useCallback(
    (data: CallBackProps) => {
      if (data.status === STATUS.FINISHED || data.status === STATUS.SKIPPED) {
        onClose();
      }
    },
    [onClose],
  );

  return (
    <Joyride
      run={run}
      steps={steps}
      continuous
      showProgress
      showSkipButton
      scrollToFirstStep
      disableScrollParentFix
      callback={handleCallback}
      locale={{
        back: 'Atrás',
        close: 'Cerrar',
        last: 'Listo',
        next: 'Siguiente',
        skip: 'Omitir',
      }}
      styles={{
        options: {
          primaryColor: theme.palette.primary.main,
          textColor: theme.palette.text.primary,
          zIndex: 14000,
        },
        tooltipContainer: {
          textAlign: 'left',
        },
        buttonNext: {
          borderRadius: 8,
          fontWeight: 700,
        },
        buttonBack: {
          borderRadius: 8,
        },
        buttonSkip: {
          color: theme.palette.text.secondary,
        },
      }}
    />
  );
}
